import React, { Component } from 'react';
import {
  FloatingActionButton,
  FontIcon,
  Dialog,
  FlatButton,
  RaisedButton,
  TextField,
} from 'material-ui';

export default class NewButtonDialog extends Component {
  constructor(props){
    super(props);
    this.state = {
      showDialog: false,
    }
  }

  render() {
    return (
      <FloatingActionButton
        style={{
          position: 'fixed',
          bottom: 10,
          left: 10,
          zIndex: 100,
        }}
        onTouchTap={() => this.setState({showDialog: true})}
      >
        <FontIcon className="material-icons">add</FontIcon>

        <Dialog
          title={this.props.title}
          actions={[
            <FlatButton
              label="Cancel"
              primary={true}
              onTouchTap={() => this.setState({showDialog: false})}
            />,
            <RaisedButton
              label="Create"
              primary={true}
              keyboardFocused={false}
              onTouchTap={() => {
                this.refs.newAccountForm.dispatchEvent(new Event("submit"));
              }}
            />,
          ]}
          modal={false}
          open={this.state.showDialog}
          onRequestClose={() => this.setState({showDialog: false})}
        >
          <form
            ref='newAccountForm'
            onSubmit={(e) => {
              e.preventDefault();

              const newName = this.state.newName;

              this.props.onSubmit({name: newName});
              this.setState({showDialog: false});
            }}
          >
            <TextField
              floatingLabelText="Name"
              autoFocus
              fullWidth={true}
              onChange={(e, newName) => this.setState({newName})}
            />
          </form>
        </Dialog>
      </FloatingActionButton>
    )
  }
}




// WEBPACK FOOTER //
// ./src/NewButtonDialog.js